import { DATE_FORMAT_LOCALE, DATE_FORMAT_SHORT } from '@common';

export const timestampToShortDate = (timestamp: number) => {
    return new Date(timestamp).toLocaleDateString(DATE_FORMAT_LOCALE, DATE_FORMAT_SHORT);
};
